import axios from "axios";
import FireStoreParser from "firestore-parser";
import {
  WEB_ID,
  WEB_URL,
  DOC_BASE,
  SESIONES,
  EVENTOSWEB,
  GRAPHQL_URL,
  CONTEXTO,
  BASE_URL,
  ENV,
} from "@/config/webConfig";
import moment from "moment";
moment.locale("es");

const RESPUESTA = {
  mensaje: "sin datos",
  contenido: [],
  cargando: true,
  hayDatos: false,
  status: "NOK",
};

export async function subirImagen(data) {
  var url_dev = "https://webservices.janto.es/jantoApi.des/S3/upload";
  var url_pro = "https://webservices.janto.es/jantoApi/S3/upload";
  const url = ENV == "pro" ? url_pro : url_dev;

  try {
    const respuesta = await axios.post(url, data);

    return respuesta;
  } catch (error) {
    console.log("error", error);
    return {
      statusText: "NOK",
      mensaje: "ERROR: Comprobar entorno y permisos CORS",
    };
  }
}

// otros
export function Hoy() {
  const Hoy = new Date();
  const fechaActual = {};
  const mes = Hoy.getMonth() + 1;
  const dia = Hoy.getDate();

  if (Hoy) {
    fechaActual.year = Hoy.getFullYear();
    fechaActual.mes = ("0" + mes).slice(-2);
    fechaActual.dia = ("0" + dia).slice(-2);
    fechaActual.hora = ("0" + Hoy.getHours()).slice(-2);
    fechaActual.minutos = ("0" + Hoy.getMinutes()).slice(-2);
    fechaActual.segundos = ("0" + Hoy.getSeconds()).slice(-2);
    fechaActual.ahora =
      fechaActual.year +
      fechaActual.mes +
      fechaActual.dia +
      fechaActual.hora +
      fechaActual.minutos +
      fechaActual.segundos;
  }

  return fechaActual;
}

// cargarDatos
export async function cargarDatos() {
  const { ahora } = Hoy();
  const misRecintos = {};
  const misTipos = {};
  const eventosJanto = await getEventosWeb().then(({ res }) => {
    const { data } = res;
    const { getEventosWeb } = data.data;
    const { Instalaciones } = getEventosWeb;

    const misEventos = {};

    Instalaciones.map(doc => {
      const { Eventos } = doc;
      if (!Eventos) return [];
      Eventos.filter(e => e.Tipo[0].Nombre != "Tienda")
        .filter(y => y.FInicioVentaMin < ahora)
        .forEach(evento => {
          const tipoActual = evento.Tipo[0].IdMasterTipoE;
          const idRecinto = evento.Recinto[0].Id + "@" + doc.Instalacion;
          const recintoIdJanto = evento.Recinto[0].Id;
          const recintoActual = evento.Recinto[0];
          recintoActual.idRecinto = idRecinto;
          recintoActual.Id = recintoIdJanto;
          evento.cmsID = evento.Id + "@" + doc.Instalacion;
          evento.webId = evento.cmsID + "__" + evento.Recinto[0].Id;
          evento.idRecinto = idRecinto;
          evento.recintoIdJanto = recintoIdJanto;
          if (!misEventos[evento.webId]) {
            misEventos[evento.webId] = evento;
          }
          if (!misRecintos.hasOwnProperty(idRecinto)) {
            misRecintos[idRecinto] = recintoActual;
            const eventosRecinto = [];
            recintoActual.Host = doc.Instalacion;
            recintoActual.contexto = doc.Instalacion;
            recintoActual.Provincia = evento.Provincia[0];
            recintoActual.Poblacion = evento.Poblacion[0];
            recintoActual.Instalacion = doc.Instalacion;
            recintoActual.CP = evento.CP;
            misRecintos[idRecinto] = {
              idRecinto,
              Id: recintoIdJanto,
              recinto: recintoActual,
              eventos: eventosRecinto,
            };
          }
          misRecintos[idRecinto].eventos.push(evento);
        });
    });

    return misEventos;
  });

  const datosWeb = await getWeb();
  const webItems = await getItems();

  return {
    eventosJanto,
    datosWeb,
    recintosJanto: misRecintos,
    webItems: webItems.hayDatos ? webItems.contenido : [],
    ahora,
  };
}

// nuvos

//getJmdbIdiomas
export async function getIdiomas({ id }) {
  const web = WEB_ID;
  const collection = "jmdb";
  const doc = id;
  const url = `${BASE_URL}/${web}/${collection}/${doc}/idiomas`;
  try {
    const peticion = await axios.get(url);
    if (peticion.status == 200) {
    // console.log("peticion", peticion);

      const documents = FireStoreParser(peticion.data).documents;

      if (!documents) {
        return []
      }

      const dictionary = documents.reduce((acc, item) => {
        const lang = item.name.split("/").pop(); // extract the language code from the name
        acc[lang] = item.fields; // assign the fields object to this key
        return acc;
      }, {});

      return dictionary;
    } else {
      return {
        statusText: "NOK",
      };
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}

// getJmdb
export async function getJmdb({ id }) {
  const web = WEB_ID;
  const collection = "jmdb";
  const doc = id;

  const url = web
    ? `${BASE_URL}/${web}/${collection}/${doc}`
    : `${DOC_BASE}/${collection}/${doc}`;

  try {
    const peticion = await axios.get(url);
    if (peticion.status == 200) {
      return FireStoreParser(peticion.data).fields;
    } else {
      return {
        statusText: "NOK",
      };
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}

//fin nuevos

//get Eventos web
export async function getEventosWeb() {
  let eventos = [];
  const res = await axios({
    url: GRAPHQL_URL,
    method: "post",
    data: {
      query: EVENTOSWEB,
    },
  });
// console.log("getEventosWeb", res);
  if (res.statusText != "OK") {
    console.log("dst not cod", res);
    return res;
  }

  const errors = res.data.errors;
  const datos = res.data.data.getQservlet;
  const salas = {};

  if (datos) {
  // console.log("datos", datos, res);
  }
  return {
    res,
  };
}

export async function getSesiones() {
  let eventos = [];
  const res = await axios({
    url: GRAPHQL_URL,
    method: "post",
    data: {
      query: SESIONES,
    },
  });
  if (res.statusText != "OK") {
    return res;
  }

  const errors = res.data.errors;
  const datos = res.data.data.getQservlet;
  const salas = {};

  if (datos) {
    eventos = datos.map(evento => {
      salas[evento.Id] = evento.Sesiones[0].NombreSala;
      return {
        fechas: moment(evento.Sesiones[0].HoraSes, "YYYYMMDDHH").format(),
        dates: evento.Sesiones.map(e =>
          moment(e.HoraSes, "YYYYMMDDHH").format()
        ),
        highlight: "red",
        popover: {
          label: evento.Nombre,
          isInteractive: true,
        },
        customData: evento,
      };
    });
  }
  return {
    res,
    datos,
    errors,
    eventosCalendario: eventos,
    contexto: CONTEXTO,
    salas,
  };
}

export async function getData() {
  const peticion = await axios.get(WEB_URL);
  const respuesta = Object.assign({}, RESPUESTA);
  if (peticion.status == 200) {
    respuesta.hayDatos = true;
    respuesta.contenido = FireStoreParser(peticion.data).fields;
    respuesta.mensaje = "datos cargados con éxito";
    respuesta.cargando = false;
    respuesta.status = "OK";
    respuesta.servicio = "getDAta";
  }

  return respuesta;
}

export async function getWeb() {
  const peticion = await axios.get(WEB_URL);
  try {
    const peticion = await axios.get(WEB_URL);
    if (peticion.status == 200) {
      return FireStoreParser(peticion.data).fields;
    } else {
      return {
        statusText: "NOK",
      };
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}

export async function getItems() {
  const web = WEB_ID;
  const collection = "items";
  // const collection = 'listaschopenhauer'
  const max = 550;
  const url = `${BASE_URL}/${web}/${collection}/?pageSize=${max}`;
  const peticion = await axios.get(url);
  const respuesta = Object.assign({}, RESPUESTA);
  // console.log("respuesta", peticion);
  const masItems = async (token, items) => {
    const url = `${BASE_URL}/${web}/${collection}/?pageSize=${max}&pageToken=${token}`;
    const peticion = await axios.get(url);

    // add peticion.data.documents to items
    items = items.concat(peticion.data.documents);
    if (peticion.data.nextPageToken) {
      return masItems(peticion.data.nextPageToken, items);
    }

    return items;
  };

  if (peticion.status == 200 && peticion.data.documents) {
    if (peticion.data.nextPageToken) {
      peticion.data.documents = await masItems(
        peticion.data.nextPageToken,
        peticion.data.documents
      );
    }
    const datos = FireStoreParser(peticion.data);

    respuesta.hayDatos = true;
    respuesta.contenido = datos.documents.map(e => e.fields);
    respuesta.mensaje = "datos cargados con éxito";
    respuesta.cargando = false;
    respuesta.status = "OK";
    respuesta.servicio = "getItems";
  }

  return respuesta;
}

export async function getBanners() {
  const web = WEB_ID;
  const collection = "banners";
  const max = 550;
  const url = `${BASE_URL}/${web}/${collection}/?pageSize=${max}`;
  const peticion = await axios.get(url);
  const respuesta = Object.assign({}, RESPUESTA);
  
  const masBanners = async (token, banners) => {
    const url = `${BASE_URL}/${web}/${collection}/?pageSize=${max}&pageToken=${token}`;
    const peticion = await axios.get(url);

    // add peticion.data.documents to banners
    banners = banners.concat(peticion.data.documents);
    if (peticion.data.nextPageToken) {
      return masBanners(peticion.data.nextPageToken, banners);
    }

    return banners;
  };

  if (peticion.status == 200 && peticion.data.documents) {
    if (peticion.data.nextPageToken) {
      peticion.data.documents = await masBanners(
        peticion.data.nextPageToken,
        peticion.data.documents
      );
    }
    const datos = FireStoreParser(peticion.data);

    respuesta.hayDatos = true;
    respuesta.contenido = datos.documents.map(e => e.fields);
    respuesta.mensaje = "datos cargados con éxito";
    respuesta.cargando = false;
    respuesta.status = "OK";
    respuesta.servicio = "getBanners";
  }

  return respuesta;
}

export async function getBanner(id) {
  const web = WEB_ID;
  const collection = "banners";
  const url = `${BASE_URL}/${web}/${collection}/${id}`;
  
  try {
    const peticion = await axios.get(url);
    if (peticion.status == 200) {
      return FireStoreParser(peticion.data).fields;
    } else {
      return {
        statusText: "NOK",
      };
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}

export async function getItemsOld() {
  const collection = "listaschopenhauer";
  const max = 150;
  const url = `${WEB_URL}/${collection}/?pageSize=${max}`;
  const peticion = await axios.get(url);
  const respuesta = Object.assign({}, RESPUESTA);
  const { data } = peticion;
  if (peticion.status == 200 && data.documents) {
    const datos = FireStoreParser(data);
    const hayDatos = datos.documents.length > 0 ? true : false;
    respuesta.hayDatos = hayDatos;
    respuesta.contenido = hayDatos ? datos.documents.map(e => e.fields) : [];
    respuesta.mensaje = hayDatos ? "datos cargados con éxito" : "sin datos";
    respuesta.cargando = false;
    respuesta.status = hayDatos ? "OK" : "NOK";
    respuesta.servicio = "getItemsOld";
  }

  return respuesta;
}

export async function getColeccion({ web, collection, orden }) {
  // const collection = 'listaschopenhauer'
  const max = 150;
  const url = `${BASE_URL}/${web}/${collection}/?orderBy=${
    orden ? orden : "orden"
  }&pageSize=${max}`;
  const peticion = await axios.get(url);
  const respuesta = Object.assign({}, RESPUESTA);
  // console.log('respuesta', peticion);
  if (peticion.status == 200 && peticion.data.documents) {
    const datos = FireStoreParser(peticion.data);
    // console.log('FIELDS', datos)
    respuesta.hayDatos = true;
    respuesta.contenido = datos.documents.map(e => e.fields);
    respuesta.mensaje = "datos cargados con éxito";
    respuesta.cargando = false;
    respuesta.status = "OK";
    respuesta.servicio = "getColeccion";
  }

  return respuesta;
}

export async function getDoc({ web, collection, doc }) {
  // const collection = 'listaschopenhauer'
  const url = web
    ? `${BASE_URL}/${web}/${collection}/${doc}`
    : `${DOC_BASE}/${collection}/${doc}`;
  const peticion = await axios.get(url);
  const respuesta = Object.assign({}, RESPUESTA);
  if (peticion.status == 200) {
    respuesta.hayDatos = true;
    respuesta.contenido = FireStoreParser(peticion.data).fields;
    respuesta.mensaje = "datos cargados con éxito";
    respuesta.cargando = false;
    respuesta.status = "OK";
    respuesta.servicio = "getDoc";
  }
  return respuesta;
}
